const options:any = { year: 'numeric', month: 'short', day: '2-digit' };

const dateFormatter = (dateValue: string) => new Date(dateValue).toLocaleDateString("en-GB", options)

export default dateFormatter;